export * from './adminRegistrationController.service';
import { AdminRegistrationControllerService } from './adminRegistrationController.service';
export * from './publicRegistrationController.service';
import { PublicRegistrationControllerService } from './publicRegistrationController.service';
export const APIS = [AdminRegistrationControllerService, PublicRegistrationControllerService];
